{
  window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame
  window.cancelAnimationFrame  = window.cancelAnimationFrame  || window.mozcancelAnimationFrame  || window.webkitcancelAnimationFrame  || window.mscancelAnimationFrame
}

{
	window.transitionEnd = (() => {
		var i,
		el = document.createElement('div'),
		transitions = {
			transition      : 'transitionend',
			MozTransition   : 'transitionend',
			WebkitTransition: 'webkitTransitionEnd'
		}
	
		for (i in transitions) {
			if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
				return transitions[i]
			}
		}
	})()
}

{
	window.animationEnd = (() => {
		var i,
		el = document.createElement('div'),
		animations = {
			animation      : 'animationend',
			MozAnimation   : 'animationnend',
			WebkitAnimation: 'webkitAnimationEnd'
		}
	
		for (i in animations) {
			if (animations.hasOwnProperty(i) && el.style[i] !== undefined) {
				return animations[i]
			}
		}
	})()
}


// WEBPACK FOOTER //
// ./src/assets/js/config/polyfill.js